module.exports = __webpack_public_path__ + "assets/999c8190d4e16d79199d4b6bc6d3abbb.mp3";